import { viewEvents } from './mixpanelEvents';
import { mixpanelService } from './mixpanel';
import { shouldReportError } from '../util/errorReporting';

const MAX_REPORTED_ERRORS = 5;

function describe(value: unknown): string {
  if (value instanceof Error) {
    return `${value.name}: ${value.message}`;
  }
  return typeof value === 'string' ? value : 'Unknown error';
}

export function installGlobalErrorHandlers(): () => void {
  // A runaway render loop can throw continuously; cap what we forward so a single broken session
  // cannot flood ingestion.
  let reported = 0;

  const report = (source: string, detail: unknown, filename?: string) => {
    if (reported >= MAX_REPORTED_ERRORS) return;

    const message = describe(detail);
    const stack = detail instanceof Error ? detail.stack : undefined;
    if (!shouldReportError({ message, filename, stack })) return;

    reported += 1;
    mixpanelService.trackError(viewEvents.LANDING_PAGE_VIEWED, `${source}: ${message}`);
  };

  const onError = (event: ErrorEvent) =>
    report('Uncaught', event.error ?? event.message, event.filename);
  const onRejection = (event: PromiseRejectionEvent) => report('Unhandled rejection', event.reason);

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
